import React from 'react';
import '../template-file-css/document-file-template.css';


export const TCC_BiopsychosocialAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='TCC_BiopsychosocialAdult' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    {/* <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Location of Service:</span>
                            <input type='text' id="txtLocationOfService" name="txtLocationOfService" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Units of Service:</span>
                            <input type='text' id="txtUnits" name="txtUnits" className='add-only' />
                        </td>
                    </tr> */}
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Communicated With:</span>
                            <input type='text' id="txtPersonCommunicated" name="txtPersonCommunicated" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone Contact:</span>
                            <input type='text' id="txtTelephoneContact" name="txtTelephoneContact" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Presenting Problem(s) and Requested Service(s)</h3>
                <p className='w-750'>
                    <span className='eleHeader'>What is/are presenting problem(s)?</span>
                    <span className='small'>(Why are they here? In client's own words when possible.)</span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe precipitating events:</span>
                    <textarea id="txtPrecipitatingEvents" name="txtPrecipitatingEvents" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What service(s) is the client requesting?</span>
                    <textarea id="txtServiceRequested" name="txtServiceRequested" className='add-only'
                    ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># of People in Family:</span>
                            <input type='text' id="txtFamilyCount" name="txtFamilyCount" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Adjusted Monthly Income:</span>
                            <input type='text' id="txtAdjIncome" name="txtAdjIncome" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Spiritual Variables:</span>
                    <textarea id="txtSpiritualVariables" name="txtSpiritualVariables" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Cultural Variables:</span>
                    <textarea id="txtCulturalVariables" name="txtCulturalVariables" className='add-only' ></textarea>
                </p>
                <h3>Lifespan/Developmental History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>What is the client's prenatal history?:</span>
                    <span className='small'>(Include any substance abuse, physical abuse, medications, and illnesses during
                        Mother's pregnancy, prenatal exposure to alcohol, tobacco and other drugs
                    </span>
                    <textarea id="txtPrenatalHx" name="txtPrenatalHx" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Health at birth:</span>
                    <textarea id="txtHealthAtBirth" name="txtHealthAtBirth" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Developmental milestones:</span>
                    <input type="checkbox" id="chkWithinLimits" name="chkWithinLimits" className='add-only' value="chkWithinLimits" />
                    Within Normal Limits?<br />
                    <textarea id="txtDevelopmentalMilestones" name="txtDevelopmentalMilestones" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Special services received during lifetime:</span>
                    <textarea id="txtSpecialServicesReceived" name="txtSpecialServicesReceived" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other lifespan/developmental issues:</span> <span className='small'>(Include mid-life, senior/elder, other issues)</span><br />
                    <textarea id="txtOtherIssues" name="txtOtherIssues" className='add-only' ></textarea>
                </p>
                <h3>Education Assessment</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>School currently attending:</span>
                            <input type='text' id="txtCurrentSchool" name="txtCurrentSchool" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Grade:</span>
                            <input type='text' id="txtCurrentGrade" name="txtCurrentGrade" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Has the client ever been suspended or expelled from school and/or bus?:</span>
                    <span className='small'>(Include both in-school suspensions and out-of-school suspensions) If so, include
                        the number of times, dates of suspension and duration of suspension.
                    </span>
                    <textarea id="txtSuspended" name="txtSuspended" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the client have frequent absences?:</span>
                    <span className='small'>Include the number of times consumer has been absent.</span>
                    <textarea id="txtFrequentAbsences" name="txtFrequentAbsences" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client currently failing, and has the client ever been retained?:</span>
                    <textarea id="txtFailingRetained" name="txtFailingRetained" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the client in special education classes?:</span>
                    <textarea id="txtInSpecialEd" name="txtInSpecialEd" className='add-only' ></textarea>
                </p>
                <h3>Family of Origin History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Family's current and past psychiatric history:</span>
                    <textarea id="txtFamilyPsychHistory" name="txtFamilyPsychHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family's and client's physical/sexual/emotional abuse
                        history:
                    </span>
                    <textarea id="txtAbuseHistory" name="txtAbuseHistory" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family's substance use/abuse history:</span>
                    <textarea id="txtSubstanceAbuseHistory" name="txtSubstanceAbuseHistory" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client's Current and Significant Past Supports:</span>
                    <span className='small'>(Social supports, family supports, significant relationships, religious
                        and spiritual supports/affiliations.)
                    </span>
                    <br />
                    <textarea id="txtSupports" name="txtSupports" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other Agencies/Systems Involved With:</span> <span className='small'>(List agencies client is involved with or receiving services from.
                        For example: Dept of Rehab, CalWORKs, ASOC, etc. Include the name of the agency
                        and primary contact person.)
                    </span>
                    <br />
                    <textarea id="txtOtherAgencies" name="txtOtherAgencies" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    Client's Legal History:
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory1" id="chkLegalHistory1" className='add-only' value="chkLegalHistory1" />
                            Informal Probation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory2" id="chkLegalHistory2" className='add-only' value="chkLegalHistory2" />
                            Formal Probation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory3" id="chkLegalHistory3" className='add-only' value="chkLegalHistory3" />
                            Parole
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory4" id="chkLegalHistory4" className='add-only' value="chkLegalHistory4" />
                            Child Welfare Services
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory5" id="chkLegalHistory5" className='add-only' value="chkLegalHistory5" />
                            Conservatorship
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory6" id="chkLegalHistory6" className='add-only' value="chkLegalHistory6" />
                            D. U. I.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkLegalHistory7" id="chkLegalHistory7" className='add-only' value="chkLegalHistory7" />
                            Restraining Order
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkLegalHistory8" id="chkLegalHistory8" className='add-only' value="chkLegalHistory8" />
                            None reported
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>(Describe and, if currently involved, give name of probation officer,
                        parole office, or case manager and estimated start and end dates.)
                    </span>
                    <br />
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only' ></textarea>
                </p>

                <p className='w-750'>
                    <span> Client's Substance Use:  </span><br />
                    <span className='small'>(Alcohol and other drugs, check all that apply.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'> <input type="checkbox" name="chkSubstanceUse1" id="chkSubstanceUse1" value="chkSubstanceUse1" className='add-only' /> Caffeine </td>
                        <td className='w-250'> <input type="checkbox" name="chkSubstanceUse2" id="chkSubstanceUse2" value="chkSubstanceUse2" className='add-only' /> Tobacco </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse3" id="chkSubstanceUse3" value="chkSubstanceUse3" className='add-only' />
                            Over-the-counter Medication
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse4" id="chkSubstanceUse4" value="chkSubstanceUse4" className='add-only' />
                            Prescription Medication
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse5" id="chkSubstanceUse5" value="chkSubstanceUse5" className='add-only' />
                            Alcohol
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse6" id="chkSubstanceUse6" value="chkSubstanceUse6" className='add-only' />
                            Inhalants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse7" id="chkSubstanceUse7" value="chkSubstanceUse7" className='add-only' />
                            Hallucinogens
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse8" id="chkSubstanceUse8" value="chkSubstanceUse8" className='add-only' />
                            Marijuana
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse9" id="chkSubstanceUse9" value="chkSubstanceUse9" className='add-only' />
                            Stimulants
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse10" id="chkSubstanceUse10" value="chkSubstanceUse10" className='add-only' />
                            Sedatives
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse11" id="chkSubstanceUse11" value="chkSubstanceUse11" className='add-only' />
                            Tranqulizers
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse12" id="chkSubstanceUse12" value="chkSubstanceUse12" className='add-only' />
                            Cocaine
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse13" id="chkSubstanceUse13" value="chkSubstanceUse13" className='add-only' />
                            Barbituates
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse14" id="chkSubstanceUse14" value="chkSubstanceUse14" className='add-only' />
                            Methamphetamines
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse15" id="chkSubstanceUse15" value="chkSubstanceUse15" className='add-only' />
                            Opiates
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkSubstanceUse16" id="chkSubstanceUse16" value="chkSubstanceUse16" className='add-only' />
                            Methadone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkSubstanceUse17" id="chkSubstanceUse17" value="chkSubstanceUse17" className='add-only' />
                            Other <input type='text' id="txtMethadoneOther" name="txtMethadoneOther" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other Substance(s):</span>
                    <input type='text' id="txtOtherSubstance" name="txtOtherSubstance" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client's history of withdrawal, DTs, blackouts (loss
                        of time), seizures, etc. If applicable.
                    </span>
                    <textarea id="txtHistoryOfWithdrawal" name="txtHistoryOfWithdrawal" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ask and record the response to, "What happens when you
                        stop using?":
                    </span>
                    <textarea id="txtWhatHappens" name="txtWhatHappens" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What is the longest period of sobriety?:</span>
                            <input type='text' id="txtLongestPeriodOfSobriety" name="txtLongestPeriodOfSobriety" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>When?:</span>
                            <input type='text' id="txtWhenPeriodOfSobriety" name="txtWhenPeriodOfSobriety" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has the client received treatment for drug and alcohol issues?</span>
                            <select id="ddlReceivedTreatment" name="ddlReceievedTreatment" className='add-only'>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, list in-patient providers, out-patient, providers, services received, dates
                        of services, and outcomes:
                    </span>
                    <textarea id="txtTreatmentOutcomes" name="txtTreatmentOutcomes" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    Patient Evaluation
                </p>
                <h3>Mental Status Exam
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAppearance1" id="chkAppearance1" className='add-only' value="chkAppearance1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAppearance2" id="chkAppearance2" className='add-only' value="chkAppearance2" />
                            Unkempt
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAppearance3" id="chkAppearance3" className='add-only' value="chkAppearance3" />
                            Atypical Clothing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkOrientation1" id="chkOrientation1" className='add-only' value="chkOrientation1" />
                            Person
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkOrientation2" id="chkOrientation2" className='add-only' value="chkOrientation2" />
                            Place
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkOrientation3" id="chkOrientation3" className='add-only' value="chkOrientation3" />
                            Date
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkOrientation4" id="chkOrientation4" className='add-only' value="chkOrientation4" />
                            Situation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="chkInsight1" id="chkInsight1" className='add-only' value="chkInsight1" />
                            Poor
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="chkInsight2" id="chkInsight2" className='add-only' value="chkInsight2" />
                            Average
                        </td>
                        <td className='w-450'>
                            <input type="checkbox" name="chkInsight3" id="chkInsight3" className='add-only' value="chkInsight3" />
                            Good
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" name="chkJudgment1" id="chkJudgment1" className='add-only' value="chkJudgment1" />
                            Poor
                        </td>
                        <td className='w-150'>
                            <input type="checkbox" name="chkJudgment2" id="chkJudgment2" className='add-only' value="chkJudgment2" />
                            Average
                        </td>
                        <td className='w-450'>
                            <input type="checkbox" name="chkJudgment3" id="chkJudgment3" className='add-only' value="chkJudgment3" />
                            Good
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtMentalStatusComments" name="txtMentalStatusComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Motor Activity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" name="chkMotorActivity1" id="chkMotorActivity1" className='add-only' value="chkMotorActivity1" />
                            Unremarkable
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="chkMotorActivity2" id="chkMotorActivity2" className='add-only' value="chkMotorActivity2" />
                            Restless
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="chkMotorActivity3" id="chkMotorActivity3" className='add-only' value="chkMotorActivity3" />
                            Withdrawn
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" name="chkMotorActivity4" id="chkMotorActivity4" className='add-only' value="chkMotorActivity4" />
                            Slurred Speech
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Biological Functions:</span>
                    <input type="checkbox" name="chkBiologicalFunctions" id="chkBiologicalFunctions" className='add-only' value="chkBiologicalFunctions" />
                    All within normal limits
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Sleep Pattern:</span>
                    <textarea id="txtSleepPattern" name="txtSleepPattern" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Appetite:</span>
                    <textarea id="txtAppetite" name="txtAppetite" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtBiologicalFunctionsComments" name="txtBiologicalFunctionsComments"
                        className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect1" id="chkAffect1" className='add-only' value="chkAffect1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect2" id="chkAffect2" className='add-only' value="chkAffect2" />
                            Angry
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect3" id="chkAffect3" className='add-only' value="chkAffect3" />
                            Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect4" id="chkAffect4" className='add-only' value="chkAffect4" />
                            Self Critical
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect5" id="chkAffect5" className='add-only' value="chkAffect5" />
                            Euphoric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect6" id="chkAffect6" className='add-only' value="chkAffect6" />
                            Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect7" id="chkAffect7" className='add-only' value="chkAffect7" />
                            Flat
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect8" id="chkAffect8" className='add-only' value="chkAffect8" />
                            Silly
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAffect9" id="chkAffect9" className='add-only' value="chkAffect9" />
                            Hopelessness
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Depressive-Like Behavior</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior1" id="chkDepressiveLikeBehavior1" className='add-only' value="chkDepressiveLikeBehavior1" />
                            None
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior2" id="chkDepressiveLikeBehavior2" className='add-only' value="chkDepressiveLikeBehavior2" />
                            Irritability
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior3" id="chkDepressiveLikeBehavior3" className='add-only' value="chkDepressiveLikeBehavior3" />
                            Withdrawn
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior4" id="chkDepressiveLikeBehavior4" className='add-only' value="chkDepressiveLikeBehavior4" />
                            Hypoactive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior5" id="chkDepressiveLikeBehavior5" className='add-only' value="chkDepressiveLikeBehavior5" />
                            Poor Concentration
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior6" id="chkDepressiveLikeBehavior6" className='add-only' value="chkDepressiveLikeBehavior6" />
                            Self-Blame/Self-Criticism
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior7" id="chkDepressiveLikeBehavior7" className='add-only' value="chkDepressiveLikeBehavior7" />
                            Fatigue
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior8" id="chkDepressiveLikeBehavior8" className='add-only' value="chkDepressiveLikeBehavior8" />
                            Sadness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior9" id="chkDepressiveLikeBehavior9" className='add-only' value="chkDepressiveLikeBehavior9" />
                            Loss of Interest
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior10" id="chkDepressiveLikeBehavior10" className='add-only' value="chkDepressiveLikeBehavior10" />
                            Feelings of Worthlessness
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior11" id="chkDepressiveLikeBehavior11" className='add-only' value="chkDepressiveLikeBehavior11" />
                            Change in Sexaul Interest
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior12" id="chkDepressiveLikeBehavior12" className='add-only' value="chkDepressiveLikeBehavior12" />
                            Crying
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior13" id="chkDepressiveLikeBehavior13" className='add-only' value="chkDepressiveLikeBehavior13" />
                            Guilt Feelings
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior14" id="chkDepressiveLikeBehavior14" className='add-only' value="chkDepressiveLikeBehavior14" />
                            Loss of Ability to Enjoy (Anhedonia)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkDepressiveLikeBehavior15" id="chkDepressiveLikeBehavior15" className='add-only' value="chkDepressiveLikeBehavior15" />
                            Feelings of Helpless/Hopeless
                        </td>
                        <td className='w-250'>&nbsp; </td>
                        <td className='w-250'>&nbsp; </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtDepressiveLikeComments" name="txtDepressiveLikeComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thinking:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking1" id="chkThinking1" className='add-only' value="chkThinking1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking2" id="chkThinking2" className='add-only' value="chkThinking2" />
                            Disorganized
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking3" id="chkThinking3" className='add-only' value="chkThinking3" />
                            Flight of Ideas
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking4" id="chkThinking4" className='add-only' value="chkThinking4" />
                            Distracted
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking5" id="chkThinking5" className='add-only' value="chkThinking5" />
                            Suspicious
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking6" id="chkThinking6" className='add-only' value="chkThinking6" />
                            Confused
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking7" id="chkThinking7" className='add-only' value="chkThinking7" />
                            Delusions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking8" id="chkThinking8" className='add-only' value="chkThinking8" />
                            Obsessions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkThinking9" id="chkThinking9" className='add-only' value="chkThinking9" />
                            Grandiosity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="chkThinking10" id="chkThinking10" className='add-only' value="chkThinking10" />
                            Hypochondriasis
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtThinkingComments" name="txtThinkingComments" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Attitude:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude1" id="chkAttitude1" className='add-only' value="chkAttitude1" />
                            Unremarkable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude2" id="chkAttitude2" className='add-only' value="chkAttitude2" />
                            Controlling
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude3" id="chkAttitude3" className='add-only' value="chkAttitude3" />
                            Passive-Aggressive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude4" id="chkAttitude4" className='add-only' value="chkAttitude4" />
                            Egocentric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude5" id="chkAttitude5" className='add-only' value="chkAttitude5" />
                            Hostile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude6" id="chkAttitude6" className='add-only' value="chkAttitude6" />
                            Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude7" id="chkAttitude7" className='add-only' value="chkAttitude7" />
                            Sarcastic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude8" id="chkAttitude8" className='add-only' value="chkAttitude8" />
                            Negativistic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude9" id="chkAttitude9" className='add-only' value="chkAttitude9" />
                            Manipulative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkAttitude10" id="chkAttitude10" className='add-only' value="chkAttitude10" />
                            Resistant
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkAttitude11" id="chkAttitude11" className='add-only' value="chkAttitude11" />
                            Passive
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id="txtAttitudeComments" name="txtAttitudeComments" className='add-only'></textarea>
                </p>
                <h3>Mental Health Services History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Current and past psychiatric history:</span>
                    <textarea id="txtPsychiatricHistory" name="txtPsychiatricHistory" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current service provider(s):</span>
                    <textarea id="txtCurrentProvider" name="txtCurrentProvider" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past service provider(s):</span> <span className='small'>(Include in-patient, out-patient, provider names, dates, therapeutic interventions
                        and outcomes.)
                    </span>
                    <textarea id="txtPastProvider" name="txtPastProvider" className='add-only' ></textarea>
                </p>
                <h3>Medical History</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Medical Conditions:</span> <span className='small'>(Document
                        significant past and present medical conditions, including allergies.)
                    </span>
                    <textarea id="txtMedicalConditions" name="txtMedicalConditions" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family Medical History:</span>
                    <textarea id="txtFamMedHx" name="txtFamMedHx" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Primary Care Physician's Contact Information:</span>
                    <textarea id="txtPrimaryCarePhysician" name="txtPrimaryCarePhysician" className='add-only'
                    ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of last physicial examinations:</span></td>
                        <td className='w-375'><span className='eleHeader'>Current with immunizations?:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type="date" id="rdpLastPhysicalExam" name="rdpLastPhysicalExam" className='add-only' /></td>
                        <td className='w-375'>
                            <select id="ddlCurrentImmunizations" name="ddlCurrentImmunizations" className='add-only' >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List alternative treatments/therapies:</span> <span className='small'>(IE: biofeedback, acupuncture, hypnosis, etc.)</span><br />
                    <textarea id="txtAlternativeTreatments" name="txtAlternativeTreatments" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If lab tests were done, list the results:</span>
                    <textarea id="txtLabResults" name="txtLabResults" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Daily Living Skills (Personal Care, Laundry, Cleaning):</span>
                    <span className='small'>(List All Tasks that consumer is able to complete/Strengths)</span><br />
                    <textarea id="txtDailyLivingSkills" name="txtDailyLivingSkills" className='add-only'
                    ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client require assistive technology?:</span>
                    <span className='small'>(If yes, specify what is needed.)</span>
                    <textarea id="txtAssistiveTechRequirements" name="txtAssistiveTechRequirements" className='add-only' ></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does client display impairment in:</span>
                    <input type="checkbox" id="cbSpeechImpairment" name="cbSpeechImpairment" className='add-only' value="cbSpeechImpairment" /> Speech
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbLangImpairment" name="cbLangImpairment" className='add-only' value="cbLangImpairment" /> Language
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" id="cbVisionImpairment" name="cbVisionImpairment" className='add-only' value="cbVisionImpairment" /> Vision
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Social/Leisure Assessment:</span> <span className='small'>(Consumer's sexual orientation, sexual behaviors, gender identity)</span><br />
                    <textarea id="txtSocialLeisure" name="txtSocialLeisure" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumers Height:</span>
                            <input type='text' id="txtConsumerHeight" name="txtConsumerHeight" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumers Weight:</span>
                            <input type='text' id="txtConsumerWeight" name="txtConsumerWeight" className='add-only w-250 custom-add-only' /> (lbs.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Consumer Satisfied with Current Weight?:</span>
                            <select id="ddlSatisfiedWithWeight" name="ddlSatisfiedWithWeight" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Eat Three Meals per Day?:</span>
                            <select id="ddlThreeMeals" name="ddlThreeMeals" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Ever Diagnosed with an Eating Disorder?:</span>
                            <select id="ddlExerciseRegularly" name="ddlExerciseRegularly" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>Consumer Need a Referral for a Nutritional Assessment?:</span>
                            <select id="ddlNutritionalAssessment" name="ddlNutritionalAssessment" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Medication History</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Medication Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Dosage</span></td>
                        <td className='w-400'><span className='eleHeader'>Effective and compliance</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_1" name="txtMedication_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_1" name="txtDosage_1" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_1" name="txtEffective_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_2" name="txtMedication_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_2" name="txtDosage_2" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_2" name="txtEffective_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_3" name="txtMedication_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_3" name="txtDosage_3" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_3" name="txtEffective_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_4" name="txtMedication_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_4" name="txtDosage_4" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_4" name="txtEffective_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_5" name="txtMedication_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_5" name="txtDosage_5" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_5" name="txtEffective_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_6" name="txtMedication_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_6" name="txtDosage_6" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_6" name="txtEffective_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type="text" id="txtMedication_7" name="txtMedication_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtDosage_7" name="txtDosage_7" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type="text" id="txtEffective_7" name="txtEffective_7" className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What is your preferred sexual orientation?</span>
                            <input type='text' id="txtSexOrient" name="txtSexOrient" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>How many partners have you had?</span>
                            <input type='text' id="txtSexPartners" name="txtSexPartners" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How many partners do you currently have?</span>
                            <input type='text' id="txtSexCurrPartners" name="txtSexCurrPartners" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>What was the last STD check?</span>
                            <input type='text' id="txtSexSTDCheck" name="txtSexSTDCheck" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Did you test positive for a STD check?</span>
                            <input type='text' id="txtSexSTDPos" name="txtSexSTDPos" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Have you ever had sex against your will?</span>
                            <input type='text' id="txtSexNC" name="txtSexNC" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Have you ever traded sex for food, money, clothing, shelter, or drugs?</span>

                            <input type='text' id="txtSexTraded" name="txtSexTraded" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Current Symptoms/Problems</h3>

                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'> Rate severity and duration for each: </span></td>
                        <td className='w-225'><span className='eleHeader'><center>Severity</center>  </span> </td>
                        <td className='w-225'><span className='eleHeader'><center>Duration</center>  </span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Anxiety:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityAnxiety" name="ddlSeverityAnxiety" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationAnxiety" name="ddlDurationAnxiety" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; 1 Month</option>
                                <option value="1 &#45; 6 Months">1 - 6 Months</option>
                                <option value="7 &#45; 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Panic Attacks:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityPanicAttacks" name="ddlSeverityPanicAttacks" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationPanicAttacks" name="ddlDurationPanicAttacks" className='add-only'>
                                <option value="None"> None </option>
                                <option value="&#60; 1 Month">&#60; 1 Month </option>
                                <option value="1 &#45; 6 Months"> 1 - 6 Months </option>
                                <option value="7 &#45; 11 Months"> 7 - 11 Months </option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Phobia:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityPhobia" name="ddlSeverityPhobia" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationPhobia" name="ddlDurationPhobia" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Obessive Compulsive:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityObsessiveCompulsive" name="ddlSeverityObsessiveCompulsive"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationObsessiveCompulsive" name="ddlDurationObsessiveCompulsive"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Somatization:</td>
                        <td className='w-225'>
                            <select id="ddlSeveritySomatization" name="ddlSeveritySomatization" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationSomatization" name="ddlDurationSomatization" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62;1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Depression:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityDepression" name="ddlSeverityDepression" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationDepression" name="ddlDurationDepression" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Impaired Memory:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityImpairedMemory" name="ddlSeverityImpairedMemory" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationImpairedMemory" name="ddlDurationImpairedMemory" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Poor Self Care Skills:</td>
                        <td className='w-225'>
                            <select id="ddlSeveritySelfCare" name="ddlSeveritySelfCare" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationSelfCare" name="ddlDurationSelfCare" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Loss of Interest:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityLossOfInterest" name="ddlSeverityLossOfInterest" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationLossOfInterest" name="ddlDurationLossOfInterest" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Sexual Dysfunction:</td>
                        <td className='w-225'>
                            <select id="ddlSeveritySexualDysfunction" name="ddlSeveritySexualDysfunction" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationSexualDysfunction" name="ddlDurationSexualDysfunction" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Sleep Disturbance:</td>
                        <td className='w-225'>
                            <select id="ddlSeveritySleepDisturbance" name="ddlSeveritySleepDisturbance" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationSleepDisturbance" name="ddlDurationSleepDisturbance" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Appetite Disturbance:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityAppetiteDisturbance" name="ddlSeverityAppetiteDisturbance"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationAppetiteDisturbance" name="ddlDurationAppetiteDisturbance"
                                className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Weight Change:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityWeightChange" name="ddlSeverityWeightChange" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationWeightChange" name="ddlDurationWeightChange" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Bizarre Ideation:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityBizzareIdeation" name="ddlSeverityBizzareIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationBizarreIdeation" name="ddlDurationBizarreIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Bizarre Behavior:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityBizarreBehavior" name="ddlSeverityBizarreBehavior" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationBizarreBehavior" name="ddlDurationBizarreBehavior" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Paranoid Ideation:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityParanoidIdeation" name="ddlSeverityParanoidIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationParanoidIdeation" name="ddlDurationParanoidIdeation" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Gender Issues:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityGenderIssues" name="ddlSeverityGenderIssues" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationGenderIssues" name="ddlDurationGenderIssues" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Eating Disorders:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityEatingDisorders" name="ddlSeverityEatingDisorders" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationEatingDisorders" name="ddlDurationEatingDisorders" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Poor Judgment:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityPoorJudgment" name="ddlSeverityPoorJudgment" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationPoorJudgment" name="ddlDurationPoorJudgment" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Lack of Support System:</td>
                        <td className='w-225'>
                            <select id="ddlSeveritySupportSystem" name="ddlSeveritySupportSystem" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationSupportSystem" name="ddlDurationSupportSystem" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Poor Interpersonal Skills:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityInterpersonal" name="ddlSeverityInterpersonal" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationInterpersonal" name="ddlDurationInterpersonal" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Conduct Problems:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityConductProblems" name="ddlSeverityConductProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationConductProblems" name="ddlDurationConductProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> School Problems:</td>
                        <td className='w-225'>
                            <select id="ddlSeveritySchoolProblems" name="ddlSeveritySchoolProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationSchoolProblems" name="ddlDurationSchoolProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Family Problems:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityFamilyProblems" name="ddlSeverityFamilyProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationFamilyProblems" name="ddlDurationFamilyProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Indep. Living Problems:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityLivingProblems" name="ddlSeverityLivingProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationLivingProblems" name="ddlDurationLivingProblems" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> Unusual Body Movements:</td>
                        <td className='w-225'>
                            <select id="ddlSeverityBodyMovements" name="ddlSeverityBodyMovements" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationBodyMovements" name="ddlDurationBodyMovements" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            Other:
                            &nbsp;
                            <input type='text' id="txtOtherSymptoms" name="txtOtherSymptoms" className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-225'>
                            <select id="ddlSeverityOther" name="ddlSeverityOther" className='add-only'>
                                <option value="None">None</option>
                                <option value="Mild">Mild</option>
                                <option value="Moderate">Moderate</option>
                                <option value="Severe">Severe</option>
                            </select>
                        </td>
                        <td className='w-225'>
                            <select id="ddlDurationOther" name="ddlDurationOther" className='add-only'>
                                <option value="None">None</option>
                                <option value="&#60; 1 Month">&#60; Month</option>
                                <option value="1 - 6 Months">1 - 6 Months</option>
                                <option value="7 - 11 Months">7 - 11 Months</option>
                                <option value="&#62; 1 Year">&#62; 1 Year</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Please describe symptoms/problems listed above in detail:</span>
                    <textarea id="txtSeveritySymptoms" name="txtSeveritySymptoms" className='add-only'
                    ></textarea>
                </p>
                <h5>Assessment of Risk:</h5>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicidality:</span>
                            <select id="ddlRiskSuicidality" name="ddlRiskSuicidality" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Homicidality:</span>
                            <select id="ddlRiskHomicidality" name="ddlRiskHomicidality" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>If risk exists, client is able to contract not to harm:</span>
                            <select id="ddlRiskNoHarm" name="ddlRiskNoHarm" className='add-only'>
                                <option value="Self">Self</option>
                                <option value="Others">Others</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Impulse Control:</span>
                            <select id="ddlRiskImpulseControl" name="ddlRiskImpulseControl" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Abuse:</span>
                            <select id="ddlRiskSubstanceAbuse" name="ddlRiskSubstanceAbuse" className='add-only'>
                                <option value="None">None</option>
                                <option value="Ideation">Ideation</option>
                                <option value="Plan">Plan</option>
                                <option value="Intent w/o Means">Intent w/o Means</option>
                                <option value="Intent w/ Means">Intent w/ Means</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Abuse Date of Last Usage:</span>
                            <input name="rpdDateOfLastUsage" type="date" id="rpdDateOfLastUsage" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Substance Abuse Age of First Usage:</span>
                            <input type='text' id="txtAgeOfFirstUsage" name="txtAgeOfFirstUsage" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Sexual Abuse Victim/Perpatrator?:</span>
                            <select id="ddlSexualAbuse" name="ddlSexualAbuse" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Access to Public or Private Transporation:</span>
                            <select id="ddlAccessToPublicTransportation" name="ddlAccessToPublicTransportation" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Medical Risks:</span>
                            <select id="ddlRiskMedical" name="ddlRiskMedical" className='add-only'>
                                <option value="N/A">N/A</option>
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                            </select>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Please explain all "Yes" answers from above:</span>
                    <textarea id="txtExplainMedicalRisks" name="txtExplainMedicalRisks" className='add-only'></textarea>
                </p>
                <h3>RISK ASSESSMENT VERSION
                </h3>
                <h3>(* elements added with permission for Lifeline centers)
                </h3>
                <p className='w-750'>
                    <strong>Instructions:</strong> Check all risk and protective factors that apply. To be completed following the patient interview, review of medical
                    record(s) and/or consultation with family members and/or other professionals.
                </p>
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>Suicidal and Self-Injury Behavior</span>
                            <span className='small'>(Past Week)</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>Lifetime</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Status</span>
                            <span className='small'>(Recent) </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal1" id="chkSuicidal1" className='add-only' value="chkSuicidal1" />
                        </td>
                        <td className='w-275'>Actual suicide attempt
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime5" id="chkLifetime5" className='add-only' value="chkLifetime5" />
                        </td>
                        <td className='w-325'>Hopelessness
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical1" id="chkClinical1" className='add-only' value="chkClinical1" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal2" id="chkSuicidal2" className='add-only' value="chkSuicidal2" />
                        </td>
                        <td className='w-275'>Interrupted attempt
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime4" id="chkLifetime4" className='add-only' value="chkLifetime4" />
                        </td>
                        <td className='w-325'>Helplessness*
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical2" id="chkClinical2" className='add-only' value="chkClinical2" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal3" id="chkSuicidal3" className='add-only' value="chkSuicidal3" />
                        </td>
                        <td className='w-275'>Aborted attempt
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime3" id="chkLifetime3" className='add-only' value="chkLifetime3" />
                        </td>
                        <td className='w-325'>Feeling Trapped*
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical3" id="chkClinical3" className='add-only' value="chkClinical3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal4" id="chkSuicidal4" className='add-only' value="chkSuicidal4" />
                        </td>
                        <td className='w-275'>Other preparatory acts to kill self
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime2" id="chkLifetime2" className='add-only' value="chkLifetime2" />
                        </td>
                        <td className='w-325'>Major depressive episode
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical4" id="chkClinical4" className='add-only' value="chkClinical4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal5" id="chkSuicidal5" className='add-only' value="chkSuicidal5" />
                        </td>
                        <td className='w-275'>Self-injury behavior w/o suicide intent
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkLifetime1" id="chkLifetime1" className='add-only' value="chkLifetime1" />
                        </td>
                        <td className='w-325'>Mixed affective episode
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical5" id="chkClinical5" className='add-only' value="chkClinical5" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Suicide Ideation  </span><span className='small'>(Most Severe in Past Week)</span>
                        </td>
                        <td className='w-325'>Command hallucinations to hurt self
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical6" id="chkClinical6" className='add-only' value="chkClinical6" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal7" id="chkSuicidal7" className='add-only' value="chkSuicidal7" />
                        </td>
                        <td className='w-325'>Wish to be dead
                        </td>
                        <td className='w-325'>Highly impulsive behavior
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical7" id="chkClinical7" className='add-only' value="chkClinical7" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal8" id="chkSuicidal8" className='add-only' value="chkSuicidal8" />
                        </td>
                        <td className='w-325'>Suicidal thoughts
                        </td>
                        <td className='w-325'>Substance abuse or dependence
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical8" id="chkClinical8" className='add-only' value="chkClinical8" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal9" id="chkSuicidal9" className='add-only' value="chkSuicidal9" />
                        </td>
                        <td className='w-325'>Suicidal thoughts with method (but without specific plan or intent to act)
                        </td>
                        <td className='w-325'>Agitation or severe anxiety
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical9" id="chkClinical9" className='add-only' value="chkClinical9" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal10" id="chkSuicidal10" className='add-only' value="chkSuicidal10" />
                        </td>
                        <td className='w-325'>Suicidal intent (without specific plan)
                        </td>
                        <td className='w-325'>Perceived burden on family or others
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical10" id="chkClinical10" className='add-only' value="chkClinical10" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal11" id="chkSuicidal11" className='add-only' value="chkSuicidal11" />
                        </td>
                        <td className='w-325'>Suicidal intent with specific plan
                        </td>
                        <td className='w-325'>Chronic physical pain or other acute medical problem (AIDS, COPD, cancer, etc.)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical12" id="chkClinical12" className='add-only' value="chkClinical12" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Activating Events </span><span className='small'>(Recent)</span>
                        </td>
                        <td className='w-325'>Homicidal ideation
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical13" id="chkClinical13" className='add-only' value="chkClinical13" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal14" id="chkSuicidal14" className='add-only' value="chkSuicidal14" />
                        </td>
                        <td className='w-325'>Recent loss or other significant negative event
                        </td>
                        <td className='w-325'>Aggressive behavior towards others
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical14" id="chkClinical14" className='add-only' value="chkClinical14" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-325'>Describe:<input type="text" name="txtOtherDescribe" id="txtOtherDescribe" className='add-only' />
                        </td>
                        <td className='w-325'>Method for suicide available (gun, pills, etc.)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical15" id="chkClinical15" className='add-only' value="chkClinical15" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-325'>&nbsp;
                        </td>
                        <td className='w-325'>Refuses or feels unable to agree to safety plan
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical16" id="chkClinical16" className='add-only' value="chkClinical16" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal17" id="chkSuicidal17" className='add-only' value="chkSuicidal17" />
                        </td>
                        <td className='w-325'>Pending incarceration or homelessness
                        </td>
                        <td className='w-325'>Sexual abuse (lifetime)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical17" id="chkClinical17" className='add-only' value="chkClinical17" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal18" id="chkSuicidal18" className='add-only' value="chkSuicidal18" />
                        </td>
                        <td className='w-325'>Current or pending isolation or feeling alone
                        </td>
                        <td className='w-325'>Family history of suicide (lifetime)
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical18" id="chkClinical18" className='add-only' value="chkClinical18" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Treatment History</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Protective Factors</span><span className='small'>(Recent)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal19" id="chkSuicidal19" className='add-only' value="chkSuicidal19" />
                        </td>
                        <td className='w-325'>Previous psychiatric diagnoses and treatments
                        </td>
                        <td className='w-325'>Identifies reasons for living
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical19" id="chkClinical19" className='add-only' value="chkClinical19" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal20" id="chkSuicidal20" className='add-only' value="chkSuicidal20" />
                        </td>
                        <td className='w-325'>Hopeless or dissatisfied with treatment
                        </td>
                        <td className='w-325'>Responsibility to family or others; living with family
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical20" id="chkClinical20" className='add-only' value="chkClinical20" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal21" id="chkSuicidal21" className='add-only' value="chkSuicidal21" />
                        </td>
                        <td className='w-325'>Noncompliant with treatment
                        </td>
                        <td className='w-325'>Supportive social network or family
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical21" id="chkClinical21" className='add-only' value="chkClinical21" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal22" id="chkSuicidal22" className='add-only' value="chkSuicidal22" />
                        </td>
                        <td className='w-325'>Not receiving treatment
                        </td>
                        <td className='w-325'>Fear of death or dying due to pain and suffering
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical22" id="chkClinical22" className='add-only' value="chkClinical22" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Risk Factors</span>
                        </td>
                        <td className='w-325'>Belief that suicide is immoral, high spirituality
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical23" id="chkClinical23" className='add-only' value="chkClinical23" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal24" id="chkSuicidal24" className='add-only' value="chkSuicidal24" />
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors1" id="txtOtherRiskFactors1" className='add-only' />
                        </td>
                        <td className='w-325'>Engaged in work or school
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical24" id="chkClinical24" className='add-only' value="chkClinical24" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal25" id="chkSuicidal25" className='add-only' value="chkSuicidal25" />
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors25" id="txtOtherRiskFactor2" className='add-only' />
                        </td>
                        <td className='w-325'>Engaged with Phone Worker *
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkClinical25" id="chkClinical25" className='add-only' value="chkClinical25" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal26" id="chkSuicidal26" className='add-only' value="chkSuicidal26" />
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors3" id="txtOtherRiskFactors3" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Other Protective Factors</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;
                        </td>
                        <td className='w-325'>&nbsp;
                        </td>
                        <td className='w-325'>
                            <input type="text" name="txtOtherRiskFactors24" id="txtOtherRiskFactors24" className='add-only' />
                        </td>
                        <td className='w-50'>
                            <input type="checkbox" name="chkSuicidal27" id="chkSuicidal27" className='add-only' value="chkSuicidal27" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any suicidal, self-injury or aggressive behavior </span><span className='small'>(include dates):</span>
                    <textarea id="txtSuicidalSelf" name="txtSuicidalSelf" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Risk History:</span> <span className='small'>(Explain any
                        significant history of suicidal, homicidal, impulse control, medical or substance
                        abuse behavior that may affect client's current level of risk or impairment to functioning.
                        Include description of plan/ideation/intent checked above.)
                    </span>
                    <br />
                    <textarea id="txtRiskHistory" name="txtRiskHistory" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                <h3>Summary of Consumer's SNAPS (Strengths, Needs, Abilities, Preferences)</h3>
                <h5>Consumer's Goals/Hopes for the Future</h5>

                </p>


                <p className='w-750'>
                    <span className='eleHeader'>What things do you like about yourself?:</span>
                    <textarea id="txtLikeYourself" name="txtLikeYourself" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What things would you like to improve?:</span>
                    <textarea id="txtLikeToImprove" name="txtLikeToImprove" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What are your goals for improving these behaviors?:</span>
                    <textarea id="txtImpBehGoals" name="txtImpBehGoals" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What accomplishments are you most proud of in your personal life?:</span>
                    <textarea id="txtAccomplishments" name="txtAccomplishments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Consumer's and family's expectations from participating in this program?:</span>
                    <textarea id="txtConFamExpects" name="txtConFamExpects" className='add-only'></textarea>
                </p>
                <h5>Summary of consumer's SNAPS (Strengths, Needs, Abilities and Preferences)</h5>
                <p className='w-750'>
                    <span className='eleHeader'>Strengths:</span>
                    <textarea id="txtSNAPStrengths" name="txtSNAPStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs:</span>
                    <textarea id="txtSNAPNeeds" name="txtSNAPNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities:</span>
                    <textarea id="txtSNAPAbilities" name="txtSNAPAbilities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences:</span>
                    <textarea id="txtSNAPPrefs" name="txtSNAPPrefs" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Summary of Findings/Formulation:</span> <span className='small'>Identify problem areas and underlying dynamics. Include information used to make
                        differential diagnosis.)
                    </span>
                    <br />
                    <textarea id="txtSummaryOfFindings" name="txtSummaryOfFindings" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommended Services:</span> <span className='small'>(Check
                                all that apply.)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkRecommendedServices1" id="chkRecommendedServices1" className='add-only' value="chkRecommendedServices1" />
                            Community referrals made, no further services needed
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices2" id="chkRecommendedServices2" className='add-only' value="chkRecommendedServices2" />
                            Medication assessment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices3" id="chkRecommendedServices3" className='add-only' value="chkRecommendedServices3" />
                            By primary care physician
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices4" id="chkRecommendedServices4" className='add-only' value="chkRecommendedServices4" />
                            By ASOC or CSOG psychiatrist
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices5" id="chkRecommendedServices5" className='add-only' value="chkRecommendedServices5" />
                            Individual therapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices6" id="chkRecommendedServices6" className='add-only' value="chkRecommendedServices6" />
                            Brief therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices7" id="chkRecommendedServices7" className='add-only' value="chkRecommendedServices7" />
                            Long-term therapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices8" id="chkRecommendedServices8" className='add-only' value="chkRecommendedServices8" />
                            Family therapy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices9" id="chkRecommendedServices9" className='add-only' value="chkRecommendedServices9" />
                            Collateral
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices10" id="chkRecommendedServices10" className='add-only' value="chkRecommendedServices10" />
                            Group
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices11" id="chkRecommendedServices11" className='add-only' value="chkRecommendedServices11" />
                            Testing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkRecommendedServices12" id="chkRecommendedServices12" className='add-only' value="chkRecommendedServices12" />
                            Day rehab/treatment
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="chkRecommendedServices13" id="chkRecommendedServices13" className='add-only' value="chkRecommendedServices13" />
                            Other
                            <input type='text' id="txtRecommendedServicesOther" name="txtRecommendedServicesOther" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If community referrals were made, please describe:</span>
                    <textarea id="txtReferralsMade" name="txtReferralsMade" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>If client was placed on 1013, please give details:</span>
                    <span className='small'>(IE: Which hospital, how transported, etc.)</span><br />
                    <textarea id="txt5150Details" name="txt5150Details" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Interpretive Summary:</span>
                    <textarea id="txtInterpretiveSummary" name="txtInterpretiveSummary" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Problems List:</span>
                    <textarea id="txtProblemsList" name="txtProblemsList" className='add-only'></textarea>
                </p>
                <h3>Diagnostic Impression</h3>
                <h4>DSM-5</h4>
                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'> # Diagnosis</span></td>
                        <td className='w-250'><span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'> (1)
                            <input type='text' id="txtDSM5Dx_1" name="txtDSM5Dx_1" className='add-only w-450 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtDSM5Date_1" name="txtDSM5Date_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> (2)
                            <input type='text' id="txtDSM5Dx_2" name="txtDSM5Dx_2" className='add-only w-450 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtDSM5Date_2" name="txtDSM5Date_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> (3)
                            <input type='text' id="txtDSM5Dx_3" name="txtDSM5Dx_3" className='add-only w-450 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtDSM5Date_3" name="txtDSM5Date_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> (4)
                            <input type='text' id="txtDSM5Dx_4" name="txtDSM5Dx_4" className='add-only w-450 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtDSM5Date_4" name="txtDSM5Date_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'> (5)
                            <input type='text' id="txtDSM5Dx_5" name="txtDSM5Dx_5" className='add-only w-450 custom-add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id="txtDSM5Date_5" name="txtDSM5Date_5" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Recommendations:</span>
                    <textarea id="txtRecommendations" name="txtRecommendations" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Projected Date of Discharge/Transition:</span>
                    <input type="text" id="rdpProjectedDischargeDate" name="rdpProjectedDischargeDate" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Anticipated Stepdown:</span>
                    <textarea id="txtAnticipatedStepdown" name="txtAnticipatedStepdown" className='add-only'></textarea>
                </p>


{/* 

                <h3>ANSA
                </h3>
                <h4>LIFE DOMAIN FUNCTIONING
                </h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = no evidence of problems<br />
                    <strong>1</strong> = history, mild<br />
                    <strong>2</strong> = moderate<br />
                    <strong>3</strong> = severe
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physical/Medical</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Physical_0" name="rbLifeDomainFunctioningPhysical" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Physical_1" name="rbLifeDomainFunctioningPhysical" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Physical_2" name="rbLifeDomainFunctioningPhysical" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Physical_3" name="rbLifeDomainFunctioningPhysical" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Family Functioning</span>
                            <input type="radio" id="rbLifeDomainFunctioning_FamilyFunctioning_0" name="rbLifeDomainFunctioningFamilyFunctioning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_FamilyFunctioning_1" name="rbLifeDomainFunctioningFamilyFunctioning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_FamilyFunctioning_2" name="rbLifeDomainFunctioningFamilyFunctioning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_FamilyFunctioning_3" name="rbLifeDomainFunctioningFamilyFunctioning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Employment</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Employment_NA" name="rbLifeDomainFunctioningEmployment" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Employment_0" name="rbLifeDomainFunctioningEmployment" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Employment_1" name="rbLifeDomainFunctioningEmployment" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Employment_2" name="rbLifeDomainFunctioningEmployment" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Employment_3" name="rbLifeDomainFunctioningEmployment" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Social Functioning</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning_0" name="rbLifeDomainFunctioningSocialFunctioning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning_1" name="rbLifeDomainFunctioningSocialFunctioning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning_2" name="rbLifeDomainFunctioningSocialFunctioning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SocialFunctioning_3" name="rbLifeDomainFunctioningSocialFunctioning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Recreational</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational_0" name="rbLifeDomainFunctioningRecreational" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational_1" name="rbLifeDomainFunctioningRecreational" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational_2" name="rbLifeDomainFunctioningRecreational" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Recreational_3" name="rbLifeDomainFunctioningRecreational" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Intellectual/Developmental</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental_0" name="rbLifeDomainFunctioningDevelopmental" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental_1" name="rbLifeDomainFunctioningDevelopmental" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental_2" name="rbLifeDomainFunctioningDevelopmental" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Developmental_3" name="rbLifeDomainFunctioningDevelopmental" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Sexuality</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Sexuality_0" name="rbLifeDomainFunctioningSexuality" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sexuality_1" name="rbLifeDomainFunctioningSexuality" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sexuality_2" name="rbLifeDomainFunctioningSexuality" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sexuality_3" name="rbLifeDomainFunctioningSexuality" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Independent Living Skills</span>
                            <input type="radio" id="rbLifeDomainFunctioning_IndependentLivingSkills_0" name="rbLifeDomainFunctioningIndependentLivingSkills" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_IndependentLivingSkills_1" name="rbLifeDomainFunctioningIndependentLivingSkills" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_IndependentLivingSkills_2" name="rbLifeDomainFunctioningIndependentLivingSkills" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_IndependentLivingSkills_3" name="rbLifeDomainFunctioningIndependentLivingSkills" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Residential Stability</span>
                            <input type="radio" id="rbLifeDomainFunctioning_ResidentialStability_0" name="rbLifeDomainFunctioningResidentialStability" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_ResidentialStability_1" name="rbLifeDomainFunctioningResidentialStability" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_ResidentialStability_2" name="rbLifeDomainFunctioningResidentialStability" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_ResidentialStability_3" name="rbLifeDomainFunctioningResidentialStability" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Legal</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Legal_0" name="rbLifeDomainFunctioningLegal" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Legal_1" name="rbLifeDomainFunctioningLegal" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Legal_2" name="rbLifeDomainFunctioningLegal" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Legal_3" name="rbLifeDomainFunctioningLegal" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Sleep</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep_0" name="rbLifeDomainFunctioningSleep" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep_1" name="rbLifeDomainFunctioningSleep" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep_2" name="rbLifeDomainFunctioningSleep" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Sleep_3" name="rbLifeDomainFunctioningSleep" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Self Care</span>
                            <input type="radio" id="rbLifeDomainFunctioning_SelfCare_0" name="rbLifeDomainFunctioningSelfCare" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SelfCare_1" name="rbLifeDomainFunctioningSelfCare" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SelfCare_2" name="rbLifeDomainFunctioningSelfCare" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_SelfCare_3" name="rbLifeDomainFunctioningSelfCare" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Decision-making</span>
                            <input type="radio" id="rbLifeDomainFunctioning_DecisionMaking_0" name="rbLifeDomainFunctioningDecisionMaking" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_DecisionMaking_1" name="rbLifeDomainFunctioningDecisionMaking" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_DecisionMaking_2" name="rbLifeDomainFunctioningDecisionMaking" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_DecisionMaking_3" name="rbLifeDomainFunctioningDecisionMaking" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Involvement in Recovery</span>
                            <input type="radio" id="rbLifeDomainFunctioning_InvolvementinRecovery_0" name="rbLifeDomainFunctioningInvolvementinRecovery" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_InvolvementinRecovery_1" name="rbLifeDomainFunctioningInvolvementinRecovery" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_InvolvementinRecovery_2" name="rbLifeDomainFunctioningInvolvementinRecovery" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_InvolvementinRecovery_3" name="rbLifeDomainFunctioningInvolvementinRecovery" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Transportation</span>
                            <input type="radio" id="rbLifeDomainFunctioning_Transportation_0" name="rbLifeDomainFunctioningTransportation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Transportation_1" name="rbLifeDomainFunctioningTransportation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Transportation_2" name="rbLifeDomainFunctioningTransportation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_Transportation_3" name="rbLifeDomainFunctioningTransportation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication Compliance</span>
                            <input type="radio" id="rbLifeDomainFunctioning_MedicationCompliance_0" name="rbLifeDomainFunctioningMedicationCompliance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_MedicationCompliance_1" name="rbLifeDomainFunctioningMedicationCompliance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_MedicationCompliance_2" name="rbLifeDomainFunctioningMedicationCompliance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_MedicationCompliance_3" name="rbLifeDomainFunctioningMedicationCompliance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Parental/Caregiver Role</span>
                            <input type="radio" id="rbLifeDomainFunctioning_CaregiverRole_NA" name="rbLifeDomainFunctioningCaregiverRole" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_CaregiverRole_0" name="rbLifeDomainFunctioningCaregiverRole" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_CaregiverRole_1" name="rbLifeDomainFunctioningCaregiverRole" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_CaregiverRole_2" name="rbLifeDomainFunctioningCaregiverRole" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbLifeDomainFunctioning_CaregiverRole_3" name="rbLifeDomainFunctioningCaregiverRole" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>BEHAVIORAL HEALTH NEEDS</h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = no evidence<br />
                    <strong>1</strong> = history or sub-threshold, watch/prevent<br />
                    <strong>2</strong> = causing problems, consistent with diagnosable disorder<br />
                    <strong>3</strong> = causing severe/dangerous problems
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Psychosis</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_Psychosis_0" name="rbBehavioralHealthNeedsPsychosis" value="0" className='add-only' /> 0  &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Psychosis_1" name="rbBehavioralHealthNeedsPsychosis" value="1" className='add-only' /> 1  &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Psychosis_2" name="rbBehavioralHealthNeedsPsychosis" value="2" className='add-only' /> 2  &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Psychosis_3" name="rbBehavioralHealthNeedsPsychosis" value="3" className='add-only' /> 3
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Impulse Control</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_ImpulseControl_0" name="rbBehavioralHealthNeedsImpulseControl" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_ImpulseControl_1" name="rbBehavioralHealthNeedsImpulseControl" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_ImpulseControl_2" name="rbBehavioralHealthNeedsImpulseControl" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_ImpulseControl_3" name="rbBehavioralHealthNeedsImpulseControl" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Depression</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_Depression_0" name="rbBehavioralHealthNeedsDepression" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Depression_1" name="rbBehavioralHealthNeedsDepression" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Depression_2" name="rbBehavioralHealthNeedsDepression" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Depression_3" name="rbBehavioralHealthNeedsDepression" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Anxiety</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_Anxiety_0" name="rbBehavioralHealthNeedsAnxiety" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Anxiety_1" name="rbBehavioralHealthNeedsAnxiety" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Anxiety_2" name="rbBehavioralHealthNeedsAnxiety" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_Anxiety_3" name="rbBehavioralHealthNeedsAnxiety" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Interpersonal Problems</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_InterpersonalProblems_0" name="rbBehavioralHealthNeedsInterpersonalProblems" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_InterpersonalProblems_1" name="rbBehavioralHealthNeedsInterpersonalProblems" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_InterpersonalProblems_2" name="rbBehavioralHealthNeedsInterpersonalProblems" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_InterpersonalProblems_3" name="rbBehavioralHealthNeedsInterpersonalProblems" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Antisocial Behavior</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_AntisocialBehavior_0" name="rbBehavioralHealthNeedsAntisocialBehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AntisocialBehavior_1" name="rbBehavioralHealthNeedsAntisocialBehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AntisocialBehavior_2" name="rbBehavioralHealthNeedsAntisocialBehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AntisocialBehavior_3" name="rbBehavioralHealthNeedsAntisocialBehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Adjustment to Trauma</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_AdjustmenttoTrauma_0" name="rbBehavioralHealthNeedsAdjustmenttoTrauma" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AdjustmenttoTrauma_1" name="rbBehavioralHealthNeedsAdjustmenttoTrauma" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AdjustmenttoTrauma_2" name="rbBehavioralHealthNeedsAdjustmenttoTrauma" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AdjustmenttoTrauma_3" name="rbBehavioralHealthNeedsAdjustmenttoTrauma" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Anger Control</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_AngerControl_0" name="rbBehavioralHealthNeedsAngerControl" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AngerControl_1" name="rbBehavioralHealthNeedsAngerControl" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AngerControl_2" name="rbBehavioralHealthNeedsAngerControl" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_AngerControl_3" name="rbBehavioralHealthNeedsAngerControl" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Eating Disturbance</span>
                            <input type="radio" id="rbBehavioralHealthNeeds_EatingDisturbance_0" name="rbBehavioralHealthNeedsEatingDisturbance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_EatingDisturbance_1" name="rbBehavioralHealthNeedsEatingDisturbance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_EatingDisturbance_2" name="rbBehavioralHealthNeedsEatingDisturbance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbBehavioralHealthNeeds_EatingDisturbance_3" name="rbBehavioralHealthNeedsEatingDisturbance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>STRENGTHS</h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = centerpiece<br />
                    <strong>1</strong> = useful<br />
                    <strong>2</strong> = identified<br />
                    <strong>3</strong> = not yet identified
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Family</span>
                            <input type="radio" id="rbStrengths_Family_0" name="rbStrengthsFamily" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Family_1" name="rbStrengthsFamily" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Family_2" name="rbStrengthsFamily" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Family_3" name="rbStrengthsFamily" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Social Connectedness</span>
                            <input type="radio" id="rbStrengths_SocialConnectedness_0" name="rbStrengthsSocialConnectedness" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_SocialConnectedness_1" name="rbStrengthsSocialConnectedness" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_SocialConnectedness_2" name="rbStrengthsSocialConnectedness" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_SocialConnectedness_3" name="rbStrengthsSocialConnectedness" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Optimism</span>
                            <input type="radio" id="rbStrengths_Optimism_0" name="rbStrengthsOptimism" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Optimism_1" name="rbStrengthsOptimism" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Optimism_2" name="rbStrengthsOptimism" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Optimism_3" name="rbStrengthsOptimism" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Talents/Interest</span>
                            <input type="radio" id="rbStrengths_TalentsInterest_0" name="rbStrengthsTalentsInterest" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_TalentsInterest_1" name="rbStrengthsTalentsInterest" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_TalentsInterest_2" name="rbStrengthsTalentsInterest" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_TalentsInterest_3" name="rbStrengthsTalentsInterest" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Educational</span>
                            <input type="radio" id="rbStrengths_Educational_NA" name="rbStrengthsEducational" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Educational_0" name="rbStrengthsEducational" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Educational_1" name="rbStrengthsEducational" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Educational_2" name="rbStrengthsEducational" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Educational_3" name="rbStrengthsEducational" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Volunteering</span>
                            <input type="radio" id="rbStrengths_Volunteering_0" name="rbStrengthsVolunteering" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Volunteering_1" name="rbStrengthsVolunteering" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Volunteering_2" name="rbStrengthsVolunteering" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Volunteering_3" name="rbStrengthsVolunteering" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Job History</span>
                            <input type="radio" id="rbStrengths_JobHistory_0" name="rbStrengthsJobHistory" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_JobHistory_1" name="rbStrengthsJobHistory" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_JobHistory_2" name="rbStrengthsJobHistory" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_JobHistory_3" name="rbStrengthsJobHistory" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Spiritual/Religious</span>
                            <input type="radio" id="rbStrengths_Religious_0" name="rbStrengthsReligious" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Religious_1" name="rbStrengthsReligious" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Religious_2" name="rbStrengthsReligious" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Religious_3" name="rbStrengthsReligious" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Community Connection</span>
                            <input type="radio" id="rbStrengths_CommunityConnection_0" name="rbStrengthsCommunityConnection" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_CommunityConnection_1" name="rbStrengthsCommunityConnection" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_CommunityConnection_2" name="rbStrengthsCommunityConnection" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_CommunityConnection_3" name="rbStrengthsCommunityConnection" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Natural Supports</span>
                            <input type="radio" id="rbStrengths_NaturalSupports_0" name="rbStrengthsNaturalSupports" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_NaturalSupports_1" name="rbStrengthsNaturalSupports" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_NaturalSupports_2" name="rbStrengthsNaturalSupports" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_NaturalSupports_3" name="rbStrengthsNaturalSupports" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Resiliency</span>
                            <input type="radio" id="rbStrengths_Resiliency_0" name="rbStrengthsResiliency" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Resiliency_1" name="rbStrengthsResiliency" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Resiliency_2" name="rbStrengthsResiliency" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Resiliency_3" name="rbStrengthsResiliency" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Resourcefulness</span>
                            <input type="radio" id="rbStrengths_Resourcefulness_0" name="rbStrengthsResourcefulness" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Resourcefulness_1" name="rbStrengthsResourcefulness" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Resourcefulness_2" name="rbStrengthsResourcefulness" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbStrengths_Resourcefulness_3" name="rbStrengthsResourcefulness" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>RISK BEHAVIORS
                </h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = no evidence<br />
                    <strong>1</strong> = history, watch/prevent<br />
                    <strong>2</strong> = recent, act<br />
                    <strong>3</strong> = acute, act immediately
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Suicide Risk</span>
                            <input type="radio" id="rbRiskBehaviors_SuicideRisk_0" name="rbRiskBehaviorsSuicideRisk" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SuicideRisk_1" name="rbRiskBehaviorsSuicideRisk" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SuicideRisk_2" name="rbRiskBehaviorsSuicideRisk" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SuicideRisk_3" name="rbRiskBehaviorsSuicideRisk" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Danger to Others</span>
                            <input type="radio" id="rbRiskBehaviors_DangertoOthers_0" name="rbRiskBehaviorsDangertoOthers" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_DangertoOthers_1" name="rbRiskBehaviorsDangertoOthers" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_DangertoOthers_2" name="rbRiskBehaviorsDangertoOthers" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_DangertoOthers_3" name="rbRiskBehaviorsDangertoOthers" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Self Injurious Behavior</span>
                            <input type="radio" id="rbRiskBehaviors_SelfInjuriousBehavior_0" name="rbRiskBehaviorsSelfInjuriousBehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SelfInjuriousBehavior_1" name="rbRiskBehaviorsSelfInjuriousBehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SelfInjuriousBehavior_2" name="rbRiskBehaviorsSelfInjuriousBehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SelfInjuriousBehavior_3" name="rbRiskBehaviorsSelfInjuriousBehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Other Self Harm</span>
                            <input type="radio" id="rbRiskBehaviors_OtherSelfHarm_0" name="rbRiskBehaviorsOtherSelfHarm" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_OtherSelfHarm_1" name="rbRiskBehaviorsOtherSelfHarm" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_OtherSelfHarm_2" name="rbRiskBehaviorsOtherSelfHarm" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_OtherSelfHarm_3" name="rbRiskBehaviorsOtherSelfHarm" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Exploitation</span>
                            <input type="radio" id="rbRiskBehaviors_Exploitation_0" name="rbRiskBehaviorsExploitation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_Exploitation_1" name="rbRiskBehaviorsExploitation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_Exploitation_2" name="rbRiskBehaviorsExploitation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_Exploitation_3" name="rbRiskBehaviorsExploitation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gambling</span>
                            <input type="radio" id="rbRiskBehaviors_Gambling_0" name="rbRiskBehaviorsGambling" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_Gambling_1" name="rbRiskBehaviorsGambling" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_Gambling_2" name="rbRiskBehaviorsGambling" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_Gambling_3" name="rbRiskBehaviorsGambling" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Sexual Aggression</span>
                            <input type="radio" id="rbRiskBehaviors_SexualAggression_0" name="rbRiskBehaviorsSexualAggression" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SexualAggression_1" name="rbRiskBehaviorsSexualAggression" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SexualAggression_2" name="rbRiskBehaviorsSexualAggression" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_SexualAggression_3" name="rbRiskBehaviorsSexualAggression" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Criminal Behavior</span>
                            <input type="radio" id="rbRiskBehaviors_CriminalBehavior_0" name="rbRiskBehaviorsCriminalBehavior" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_CriminalBehavior_1" name="rbRiskBehaviorsCriminalBehavior" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_CriminalBehavior_2" name="rbRiskBehaviorsCriminalBehavior" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbRiskBehaviors_CriminalBehavior_3" name="rbRiskBehaviorsCriminalBehavior" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>ACCULTURATION
                </h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = no evidence<br />
                    <strong>1</strong> = minimal needs<br />
                    <strong>2</strong> = moderate needs<br />
                    <strong>3</strong> = severe needs
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Language</span>
                            <input type="radio" id="rbAcculturation_Language_0" name="rbAcculturationLanguage" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Language_1" name="rbAcculturationLanguage" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Language_2" name="rbAcculturationLanguage" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Language_3" name="rbAcculturationLanguage" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Cultural Identity</span>
                            <input type="radio" id="rbAcculturation_CulturalIdentity_0" name="rbAcculturationCulturalIdentity" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalIdentity_1" name="rbAcculturationCulturalIdentity" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalIdentity_2" name="rbAcculturationCulturalIdentity" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalIdentity_3" name="rbAcculturationCulturalIdentity" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Ritual</span>
                            <input type="radio" id="rbAcculturation_Ritual1_0" name="rbAcculturationRitual1" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Ritual1_1" name="rbAcculturationRitual1" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Ritual1_2" name="rbAcculturationRitual1" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_Ritual1_3" name="rbAcculturationRitual1" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Cultural Stress</span>
                            <input type="radio" id="rbAcculturation_CulturalStress_0" name="rbAcculturationCulturalStress" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalStress_1" name="rbAcculturationCulturalStress" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalStress_2" name="rbAcculturationCulturalStress" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAcculturation_CulturalStress_3" name="rbAcculturationCulturalStress" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>SUBSTANCE USE</h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = no evidence<br />
                    <strong>1</strong> = history, watch/prevent<br />
                    <strong>2</strong> = recent, act<br />
                    <strong>3</strong> = acute, act immediately
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Substance Use</span>
                            <input type="radio" id="rbSud_SubstanceofUse_0" name="rbSubstanceofUse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SubstanceofUse_1" name="rbSubstanceofUse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SubstanceofUse_2" name="rbSubstanceofUse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SubstanceofUse_3" name="rbSubstanceofUse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Severity of Use</span>
                            <input type="radio" id="rbSud_SeverityofUse_0" name="rbSudSeverityofUse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SeverityofUse_1" name="rbSudSeverityofUse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SeverityofUse_2" name="rbSudSeverityofUse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SeverityofUse_3" name="rbSudSeverityofUse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Duration of Use</span>
                            <input type="radio" id="rbSud_DurationofUse_0" name="rbSudDurationofUse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_DurationofUse_1" name="rbSudDurationofUse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_DurationofUse_2" name="rbSudDurationofUse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_DurationofUse_3" name="rbSudDurationofUse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Stage of Recovery</span>
                            <input type="radio" id="rbSud_StageofRecovery_0" name="rbSudStageofRecovery" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_StageofRecovery_1" name="rbSudStageofRecovery" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_StageofRecovery_2" name="rbSudStageofRecovery" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_StageofRecovery_3" name="rbSudStageofRecovery" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Peer Influences</span>
                            <input type="radio" id="rbSud_PeerInfluences_0" name="rbSudPeerInfluences" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_PeerInfluences_1" name="rbSudPeerInfluences" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_PeerInfluences_2" name="rbSudPeerInfluences" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_PeerInfluences_3" name="rbSudPeerInfluences" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Environmental Influences</span>
                            <input type="radio" id="rbSud_EnvironmentalInfluences_0" name="rbSudEnvironmentalInfluences" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_EnvironmentalInfluences_1" name="rbSudEnvironmentalInfluences" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_EnvironmentalInfluences_2" name="rbSudEnvironmentalInfluences" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_EnvironmentalInfluences_3" name="rbSudEnvironmentalInfluences" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Recovery Support in Community</span>
                            <input type="radio" id="rbSud_RecoverySupportinCommunity_0" name="rbSudRecoverySupportinCommunity" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_RecoverySupportinCommunity_1" name="rbSudRecoverySupportinCommunity" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_RecoverySupportinCommunity_2" name="rbSudRecoverySupportinCommunity" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_RecoverySupportinCommunity_3" name="rbSudRecoverySupportinCommunity" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>OPTIONAL CAREGIVER STRENGTHS & NEEDS
                </h4>
                <p className='w-750'>
                    <strong>Scoring Key</strong><br />
                    <strong>0</strong> = no evidence<br />
                    <strong>1</strong> = minimal needs<br />
                    <strong>2</strong> = moderate needs<br />
                    <strong>3</strong> = severe needs
                </p>
                <p className='w-750'>
                    <input type="radio" id="rbOptionalCaregiver" name="rbOptionalCaregiver" value="0" />
                    Not applicable-no caregiver identified
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physical/Behavioral Health</span>
                            <input type="radio" id="rbOptionalCaregiver_BehavioralHealth_0" name="rbOptionalCaregiverBehavioralHealth" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_BehavioralHealth_1" name="rbOptionalCaregiverBehavioralHealth" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_BehavioralHealth_2" name="rbOptionalCaregiverBehavioralHealth" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_BehavioralHealth_3" name="rbOptionalCaregiverBehavioralHealth" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Involvement</span>
                            <input type="radio" id="rbOptionalCaregiver_Involvement_0" name="rbOptionalCaregiverInvolvement" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Involvement_1" name="rbOptionalCaregiverInvolvement" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Involvement_2" name="rbOptionalCaregiverInvolvement" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Involvement_3" name="rbOptionalCaregiverInvolvement" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Knowledge</span>
                            <input type="radio" id="rbOptionalCaregiver_Knowledge_0" name="rbOptionalCaregiverKnowledge" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Knowledge_1" name="rbOptionalCaregiverKnowledge" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Knowledge_2" name="rbOptionalCaregiverKnowledge" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Knowledge_3" name="rbOptionalCaregiverKnowledge" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Social Resources</span>
                            <input type="radio" id="rbOptionalCaregiver_SocialResources_0" name="rbOptionalCaregiverSocialResources" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_SocialResources_1" name="rbOptionalCaregiverSocialResources" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_SocialResources_2" name="rbOptionalCaregiverSocialResources" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_SocialResources_3" name="rbOptionalCaregiverSocialResources" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Family Stress</span>
                            <input type="radio" id="rbOptionalCaregiver_FamilyStress_0" name="rbOptionalCaregiverFamilyStress" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_FamilyStress_1" name="rbOptionalCaregiverFamilyStress" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_FamilyStress_2" name="rbOptionalCaregiverFamilyStress" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_FamilyStress_3" name="rbOptionalCaregiverFamilyStress" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Safety</span>
                            <input type="radio" id="rbOptionalCaregiver_Safety_0" name="rbOptionalCaregiverSafety" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Safety_1" name="rbOptionalCaregiverSafety" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Safety_2" name="rbOptionalCaregiverSafety" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbOptionalCaregiver_Safety_3" name="rbOptionalCaregiverSafety" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h3>MODULES</h3>
                <h4>VOCATIONAL/CAREER</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Career Aspirations</span>
                            <input type="radio" id="rbVocationalCareer_CareerAspirations_0" name="rbVocationalCareerCareerAspirations" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_CareerAspirations_1" name="rbVocationalCareerCareerAspirations" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_CareerAspirations_2" name="rbVocationalCareerCareerAspirations" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_CareerAspirations_3" name="rbVocationalCareerCareerAspirations" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Job Time</span>
                            <input type="radio" id="rbVocationalCareer_JobTime_0" name="rbVocationalCareerJobTime" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobTime_1" name="rbVocationalCareerJobTime" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobTime_2" name="rbVocationalCareerJobTime" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobTime_3" name="rbVocationalCareerJobTime" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Job Attendance</span>
                            <input type="radio" id="rbVocationalCareer_JobAttendance_NA" name="rbVocationalCareerJobAttendance" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobAttendance_0" name="rbVocationalCareerJobAttendance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobAttendance_1" name="rbVocationalCareerJobAttendance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobAttendance_2" name="rbVocationalCareerJobAttendance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobAttendance_3" name="rbVocationalCareerJobAttendance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Job Performance</span>
                            <input type="radio" id="rbVocationalCareer_JobPerformance_NA" name="rbVocationalCareerJobPerformance" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobPerformance_0" name="rbVocationalCareerJobPerformance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobPerformance_1" name="rbVocationalCareerJobPerformance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobPerformance_2" name="rbVocationalCareerJobPerformance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobPerformance_3" name="rbVocationalCareerJobPerformance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Job Relations</span>
                            <input type="radio" id="rbVocationalCareer_JobRelations_NA" name="rbVocationalCareerJobRelations" value="NA" className='add-only' /> NA &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobRelations_0" name="rbVocationalCareerJobRelations" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobRelations_1" name="rbVocationalCareerJobRelations" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobRelations_2" name="rbVocationalCareerJobRelations" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobRelations_3" name="rbVocationalCareerJobRelations" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Job Skills</span>
                            <input type="radio" id="rbVocationalCareer_JobSkills_0" name="rbVocationalCareerJobSkills" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobSkills_1" name="rbVocationalCareerJobSkills" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobSkills_2" name="rbVocationalCareerJobSkills" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbVocationalCareer_JobSkills_3" name="rbVocationalCareerJobSkills" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>DEVELOPMENTAL NEEDS (DD)</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Cognitive</span>
                            <input type="radio" id="rbDevelopmentalNeeds_Cognitive_0" name="rbDevelopmentalNeedsCognitive" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Cognitive_1" name="rbDevelopmentalNeedsCognitive" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Cognitive_2" name="rbDevelopmentalNeedsCognitive" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Cognitive_3" name="rbDevelopmentalNeedsCognitive" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Communication</span>
                            <input type="radio" id="rbDevelopmentalNeeds_Communication_0" name="rbDevelopmentalNeedsCommunication" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Communication_1" name="rbDevelopmentalNeedsCommunication" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Communication_2" name="rbDevelopmentalNeedsCommunication" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Communication_3" name="rbDevelopmentalNeedsCommunication" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Developmental</span>
                            <input type="radio" id="rbDevelopmentalNeeds_Developmental_0" name="rbDevelopmentalNeedsDevelopmental" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Developmental_1" name="rbDevelopmentalNeedsDevelopmental" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Developmental_2" name="rbDevelopmentalNeedsDevelopmental" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDevelopmentalNeeds_Developmental_3" name="rbDevelopmentalNeedsDevelopmental" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>PARENTING/CAREGIVER ROLE EXTENSION MODULE</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Knowledge of Needs</span>
                            <input type="radio" id="rbParentingRole_KnowledgeofNeeds_0" name="rbParentingRoleKnowledgeofNeeds" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_KnowledgeofNeeds_1" name="rbParentingRoleKnowledgeofNeeds" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_KnowledgeofNeeds_2" name="rbParentingRoleKnowledgeofNeeds" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_KnowledgeofNeeds_3" name="rbParentingRoleKnowledgeofNeeds" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Supervision</span>
                            <input type="radio" id="rbParentingRole_Supervision_0" name="rbParentingRoleSupervision" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_Supervision_1" name="rbParentingRoleSupervision" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_Supervision_2" name="rbParentingRoleSupervision" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_Supervision_3" name="rbParentingRoleSupervision" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Involvement with Care</span>
                            <input type="radio" id="rbParentingRole_InvolvementwithCare_0" name="rbParentingRoleInvolvementwithCare" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_InvolvementwithCare_1" name="rbParentingRoleInvolvementwithCare" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_InvolvementwithCare_2" name="rbParentingRoleInvolvementwithCare" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_InvolvementwithCare_3" name="rbParentingRoleInvolvementwithCare" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Organization</span>
                            <input type="radio" id="rbParentingRole_Organization_0" name="rbParentingRoleOrganization" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_Organization_1" name="rbParentingRoleOrganization" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_Organization_2" name="rbParentingRoleOrganization" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_Organization_3" name="rbParentingRoleOrganization" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Marital/Partner Violence Home</span>
                            <input type="radio" id="rbParentingRole_MaritalPartnerViolenceHome_0" name="rbParentingRoleMaritalPartnerViolenceHome" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_MaritalPartnerViolenceHome_1" name="rbParentingRoleMaritalPartnerViolenceHome" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_MaritalPartnerViolenceHome_2" name="rbParentingRoleMaritalPartnerViolenceHome" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbParentingRole_MaritalPartnerViolenceHome_3" name="rbParentingRoleMaritalPartnerViolenceHome" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>SUICIDE MODULE</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Suicide Ideation</span>
                            <input type="radio" id="rbSuicideModule_SuicideIdeation_0" name="rbSuicideModuleSuicideIdeation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideIdeation_1" name="rbSuicideModuleSuicideIdeation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideIdeation_2" name="rbSuicideModuleSuicideIdeation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideIdeation_3" name="rbSuicideModuleSuicideIdeation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Suicide Intent</span>
                            <input type="radio" id="rbSuicideModule_SuicideIntent_0" name="rbSuicideModuleSuicideIntent" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideIntent_1" name="rbSuicideModuleSuicideIntent" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideIntent_2" name="rbSuicideModuleSuicideIntent" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideIntent_3" name="rbSuicideModuleSuicideIntent" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Suicide Planning</span>
                            <input type="radio" id="rbSuicideModule_SuicidePlanning_0" name="rbSuicideModuleSuicidePlanning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicidePlanning_1" name="rbSuicideModuleSuicidePlanning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicidePlanning_2" name="rbSuicideModuleSuicidePlanning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicidePlanning_3" name="rbSuicideModuleSuicidePlanning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Suicide History</span>
                            <input type="radio" id="rbSuicideModule_SuicideHistory_0" name="rbSuicideModuleSuicideHistory" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideHistory_1" name="rbSuicideModuleSuicideHistory" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideHistory_2" name="rbSuicideModuleSuicideHistory" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSuicideModule_SuicideHistory_3" name="rbSuicideModuleSuicideHistory" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <h4>TRAUMA (Characteristics of the trauma experience)</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Sexual Abuse</span>
                            <input type="radio" id="rbTrauma_SexualAbuse_0" name="rbTraumaSexualAbuse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_SexualAbuse_1" name="rbTraumaSexualAbuse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_SexualAbuse_2" name="rbTraumaSexualAbuse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_SexualAbuse_3" name="rbTraumaSexualAbuse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Physical Abuse</span>
                            <input type="radio" id="rbTrauma_PhysicalAbuse_0" name="rbTraumaPhysicalAbuse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_PhysicalAbuse_1" name="rbTraumaPhysicalAbuse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_PhysicalAbuse_2" name="rbTraumaPhysicalAbuse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_PhysicalAbuse_3" name="rbTraumaPhysicalAbuse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Emotional Abuse</span>
                            <input type="radio" id="rbTrauma_EmotionalAbuse_0" name="rbTraumaEmotionalAbuse" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_EmotionalAbuse_1" name="rbTraumaEmotionalAbuse" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_EmotionalAbuse_2" name="rbTraumaEmotionalAbuse" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_EmotionalAbuse_3" name="rbTraumaEmotionalAbuse" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medical Trauma</span>
                            <input type="radio" id="rbTrauma_MedicalTrauma_0" name="rbTraumaMedicalTrauma" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_MedicalTrauma_1" name="rbTraumaMedicalTrauma" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_MedicalTrauma_2" name="rbTraumaMedicalTrauma" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_MedicalTrauma_3" name="rbTraumaMedicalTrauma" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Natural/Manmade Disaster</span>
                            <input type="radio" id="rbTrauma_ManmadeDisaster_0" name="rbTraumaManmadeDisaster" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_ManmadeDisaster_1" name="rbTraumaManmadeDisaster" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_ManmadeDisaster_2" name="rbTraumaManmadeDisaster" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_ManmadeDisaster_3" name="rbTraumaManmadeDisaster" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Witness/Victim to Family Violence</span>
                            <input type="radio" id="rbTrauma_VictimtoFamily_0" name="rbTraumaVictimtoFamily" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_VictimtoFamily_1" name="rbTraumaVictimtoFamily" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_VictimtoFamily_2" name="rbTraumaVictimtoFamily" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTrauma_VictimtoFamily_3" name="rbTraumaVictimtoFamily" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Witness/Victim to Community Violence</span>
                            <input type="radio" id="rbTraumaVictimto_CommunityViolence_0" name="rbTraumaVictimtoCommunityViolence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaVictimto_CommunityViolence_1" name="rbTraumaVictimtoCommunityViolence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaVictimto_CommunityViolence_2" name="rbTraumaVictimtoCommunityViolence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbTraumaVictimto_CommunityViolence_3" name="rbTraumaVictimtoCommunityViolence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>ADJUSTMENT</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Affect Regulation</span>
                            <input type="radio" id="rbAdjustment_AffectRegulation_0" name="rbAdjustmentAffectRegulation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_AffectRegulation_1" name="rbAdjustmentAffectRegulation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_AffectRegulation_2" name="rbAdjustmentAffectRegulation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_AffectRegulation_3" name="rbAdjustmentAffectRegulation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Intrusions</span>
                            <input type="radio" id="rbAdjustment_Intrusions_0" name="rbAdjustmentIntrusions" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Intrusions_1" name="rbAdjustmentIntrusions" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Intrusions_2" name="rbAdjustmentIntrusions" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Intrusions_3" name="rbAdjustmentIntrusions" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Attachment</span>
                            <input type="radio" id="rbAdjustment_Attachment_0" name="rbAdjustmentAttachment" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Attachment_1" name="rbAdjustmentAttachment" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Attachment_2" name="rbAdjustmentAttachment" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Attachment_3" name="rbAdjustmentAttachment" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Dissociation</span>
                            <input type="radio" id="rbAdjustment_Dissociation_0" name="rbAdjustmentDissociation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Dissociation_1" name="rbAdjustmentDissociation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Dissociation_2" name="rbAdjustmentDissociation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbAdjustment_Dissociation_3" name="rbAdjustmentDissociation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>DANGEROUSNESS MODULE</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Intent</span>
                            <input type="radio" id="rbDangerousnessModule_Intent_0" name="rbDangerousnessModuleIntent" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Intent_1" name="rbDangerousnessModuleIntent" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Intent_2" name="rbDangerousnessModuleIntent" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Intent_3" name="rbDangerousnessModuleIntent" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Planning</span>
                            <input type="radio" id="rbDangerousnessModule_Planning_0" name="rbDangerousnessModulePlanning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Planning_1" name="rbDangerousnessModulePlanning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Planning_2" name="rbDangerousnessModulePlanning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Planning_3" name="rbDangerousnessModulePlanning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Violence History</span>
                            <input type="radio" id="rbDangerousnessModule_ViolenceHistory_0" name="rbDangerousnessModuleViolenceHistory" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ViolenceHistory_1" name="rbDangerousnessModuleViolenceHistory" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ViolenceHistory_2" name="rbDangerousnessModuleViolenceHistory" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ViolenceHistory_3" name="rbDangerousnessModuleViolenceHistory" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Frustration Management</span>
                            <input type="radio" id="rbDangerousnessModule_FrustrationManagement_0" name="rbDangerousnessModuleFrustrationManagement" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_FrustrationManagement_1" name="rbDangerousnessModuleFrustrationManagement" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_FrustrationManagement_2" name="rbDangerousnessModuleFrustrationManagement" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_FrustrationManagement_3" name="rbDangerousnessModuleFrustrationManagement" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Hostility</span>
                            <input type="radio" id="rbDangerousnessModule_Hostility_0" name="rbDangerousnessModuleHostility" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Hostility_1" name="rbDangerousnessModuleHostility" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Hostility_2" name="rbDangerousnessModuleHostility" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_Hostility_3" name="rbDangerousnessModuleHostility" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Paranoid Thinking</span>
                            <input type="radio" id="rbDangerousnessModule_ParanoidThinking_0" name="rbDangerousnessModuleParanoidThinking" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ParanoidThinking_1" name="rbDangerousnessModuleParanoidThinking" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ParanoidThinking_2" name="rbDangerousnessModuleParanoidThinking" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ParanoidThinking_3" name="rbDangerousnessModuleParanoidThinking" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Secondary Gains from Anger</span>
                            <input type="radio" id="rbDangerousnessModule_SecondaryGainsFromAnger_0" name="rbDangerousnessModuleSecondaryGainsFromAnger" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_SecondaryGainsFromAnger_1" name="rbDangerousnessModuleSecondaryGainsFromAnger" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_SecondaryGainsFromAnger_2" name="rbDangerousnessModuleSecondaryGainsFromAnger" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_SecondaryGainsFromAnger_3" name="rbDangerousnessModuleSecondaryGainsFromAnger" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Violent Thinking</span>
                            <input type="radio" id="rbDangerousnessModule_ViolentThinking_0" name="rbDangerousnessModuleViolentThinking" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ViolentThinking_1" name="rbDangerousnessModuleViolentThinking" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ViolentThinking_2" name="rbDangerousnessModuleViolentThinking" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbDangerousnessModule_ViolentThinking_3" name="rbDangerousnessModuleViolentThinking" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>RESILIENCY FACTORS</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Aware of Violence Potential</span>
                            <input type="radio" id="rbResiliencyFactors_AwareofViolencePotential_0" name="rbResiliencyFactorsAwareofViolencePotential" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_AwareofViolencePotential_1" name="rbResiliencyFactorsAwareofViolencePotential" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_AwareofViolencePotential_2" name="rbResiliencyFactorsAwareofViolencePotential" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_AwareofViolencePotential_3" name="rbResiliencyFactorsAwareofViolencePotential" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Response to Consequences</span>
                            <input type="radio" id="rbResiliencyFactors_ResponsetoConsequences_0" name="rbResiliencyFactorsResponsetoConsequences" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_ResponsetoConsequences_1" name="rbResiliencyFactorsResponsetoConsequences" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_ResponsetoConsequences_2" name="rbResiliencyFactorsResponsetoConsequences" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_ResponsetoConsequences_3" name="rbResiliencyFactorsResponsetoConsequences" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Commitment to Self-Control</span>
                            <input type="radio" id="rbResiliencyFactors_CommitmenttoSelfControl_0" name="rbResiliencyFactorsCommitmenttoSelfControl" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_CommitmenttoSelfControl_1" name="rbResiliencyFactorsCommitmenttoSelfControl" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_CommitmenttoSelfControl_2" name="rbResiliencyFactorsCommitmenttoSelfControl" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_CommitmenttoSelfControl_3" name="rbResiliencyFactorsCommitmenttoSelfControl" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Treatment Involvement</span>
                            <input type="radio" id="rbResiliencyFactors_TreatmentInvolvement_0" name="rbResiliencyFactorsTreatmentInvolvement" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_TreatmentInvolvement_1" name="rbResiliencyFactorsTreatmentInvolvement" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_TreatmentInvolvement_2" name="rbResiliencyFactorsTreatmentInvolvement" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbResiliencyFactors_TreatmentInvolvement_3" name="rbResiliencyFactorsTreatmentInvolvement" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>SEXUALLY AGGRESSIVE BEHAVIOR (SAB)</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship</span>
                            <input type="radio" id="rbSab_Relationship_0" name="rbSabRelationship" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_Relationship_1" name="rbSabRelationship" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_Relationship_2" name="rbSabRelationship" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_Relationship_3" name="rbSabRelationship" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Physical Force/Threat</span>
                            <input type="radio" id="rbSab_PhysicalForceThreat_0" name="rbSabPhysicalForceThreat" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_PhysicalForceThreat_1" name="rbSabPhysicalForceThreat" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_PhysicalForceThreat_2" name="rbSabPhysicalForceThreat" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_PhysicalForceThreat_3" name="rbSabPhysicalForceThreat" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Planning</span>
                            <input type="radio" id="rbSab_Planning_0" name="rbSabPlanning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_Planning_1" name="rbSabPlanning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_Planning_2" name="rbSabPlanning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_Planning_3" name="rbSabPlanning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Age Differential</span>
                            <input type="radio" id="rbSab_AgeDifferential_0" name="rbSabAgeDifferential" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_AgeDifferential_1" name="rbSabAgeDifferential" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_AgeDifferential_2" name="rbSabAgeDifferential" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_AgeDifferential_3" name="rbSabAgeDifferential" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Type of Sex Act</span>
                            <input type="radio" id="rbSab_TypeofSexAct_0" name="rbSabTypeofSexAct" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_TypeofSexAct_1" name="rbSabTypeofSexAct" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_TypeofSexAct_2" name="rbSabTypeofSexAct" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_TypeofSexAct_3" name="rbSabTypeofSexAct" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Response to Accusation</span>
                            <input type="radio" id="rbSab_ResponsetoAccusation_0" name="rbSabResponsetoAccusation" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_ResponsetoAccusation_1" name="rbSabResponsetoAccusation" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_ResponsetoAccusation_2" name="rbSabResponsetoAccusation" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSab_ResponsetoAccusation_3" name="rbSabResponsetoAccusation" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>SUBSTANCE USE (SUD)</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Severity of Use</span>
                            <input type="radio" id="rbSud_SeverityofUs_0" name="rbSudSeverityofUs" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SeverityofUs_1" name="rbSudSeverityofUs" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SeverityofUs_2" name="rbSudSeverityofUs" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_SeverityofUs_3" name="rbSudSeverityofUs" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Duration of Use</span>
                            <input type="radio" id="rbSud_DurationofUs_0" name="rbSudDurationofUs" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_DurationofUs_1" name="rbSudDurationofUs" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_DurationofUs_2" name="rbSudDurationofUs" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_DurationofUs_3" name="rbSudDurationofUs" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Stage of Recovery</span>
                            <input type="radio" id="rbSud_StageofRecover_0" name="rbSudStageofRecover" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_StageofRecover_1" name="rbSudStageofRecover" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_StageofRecover_2" name="rbSudStageofRecover" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_StageofRecover_3" name="rbSudStageofRecover" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Peer Influences</span>
                            <input type="radio" id="rbSud_PeerInfluence_0" name="rbSudPeerInfluence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_PeerInfluence_1" name="rbSudPeerInfluence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_PeerInfluence_2" name="rbSudPeerInfluence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_PeerInfluence_3" name="rbSudPeerInfluence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Environmental Influences</span>
                            <input type="radio" id="rbSud_EnvironmentalInfluence_0" name="rbSudEnvironmentalInfluence" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_EnvironmentalInfluence_1" name="rbSudEnvironmentalInfluence" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_EnvironmentalInfluence_2" name="rbSudEnvironmentalInfluence" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_EnvironmentalInfluence_3" name="rbSudEnvironmentalInfluence" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Recovery Support in Community</span>
                            <input type="radio" id="rbSud_RecoverySupportinCommunit_0" name="rbSudRecoverySupportinCommunit" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_RecoverySupportinCommunit_1" name="rbSudRecoverySupportinCommunit" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_RecoverySupportinCommunit_2" name="rbSudRecoverySupportinCommunit" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbSud_RecoverySupportinCommunit_3" name="rbSudRecoverySupportinCommunit" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
                <h4>CRIME</h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Seriousness</span>
                            <input type="radio" id="rbCrime_Seriousness_0" name="rbCrimeSeriousness" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Seriousness_1" name="rbCrimeSeriousness" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Seriousness_2" name="rbCrimeSeriousness" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Seriousness_3" name="rbCrimeSeriousness" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>History</span>
                            <input type="radio" id="rbCrime_History_0" name="rbCrimeHistory" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_History_1" name="rbCrimeHistory" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_History_2" name="rbCrimeHistory" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_History_3" name="rbCrimeHistory" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Arrests</span>
                            <input type="radio" id="rbCrime_Arrests_0" name="rbCrimeArrests" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Arrests_1" name="rbCrimeArrests" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Arrests_2" name="rbCrimeArrests" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Arrests_3" name="rbCrimeArrests" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Planning</span>
                            <input type="radio" id="rbCrime_Planning_0" name="rbCrimePlanning" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Planning_1" name="rbCrimePlanning" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Planning_2" name="rbCrimePlanning" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_Planning_3" name="rbCrimePlanning" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Community Safety</span>
                            <input type="radio" id="rbCrime_CommunitySafety_0" name="rbCrimeCommunitySafety" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_CommunitySafety_1" name="rbCrimeCommunitySafety" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_CommunitySafety_2" name="rbCrimeCommunitySafety" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_CommunitySafety_3" name="rbCrimeCommunitySafety" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Legal Compliance</span>
                            <input type="radio" id="rbCrime_LegalCompliance_0" name="rbCrimeLegalCompliance" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_LegalCompliance_1" name="rbCrimeLegalCompliance" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_LegalCompliance_2" name="rbCrimeLegalCompliance" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_LegalCompliance_3" name="rbCrimeLegalCompliance" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Peer Influences</span>
                            <input type="radio" id="rbCrime_PeerInfluences_0" name="rbCrimePeerInfluences" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_PeerInfluences_1" name="rbCrimePeerInfluences" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_PeerInfluences_2" name="rbCrimePeerInfluences" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_PeerInfluences_3" name="rbCrimePeerInfluences" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Environmental Influences</span>
                            <input type="radio" id="rbCrime_EnvironmentalInfluences_0" name="rbCrimeEnvironmentalInfluences" value="0" className='add-only' /> 0 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_EnvironmentalInfluences_1" name="rbCrimeEnvironmentalInfluences" value="1" className='add-only' /> 1 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_EnvironmentalInfluences_2" name="rbCrimeEnvironmentalInfluences" value="2" className='add-only' /> 2 &nbsp;&nbsp;
                            <input type="radio" id="rbCrime_EnvironmentalInfluences_3" name="rbCrimeEnvironmentalInfluences" value="3" className='add-only' /> 3 &nbsp;&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
 */}


                <h3>The Discharge Summary</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Discharge Plan (Outcome/Discharge Criteria):</span>
                    <textarea id="txtDischargePlan" name="txtDischargePlan" className='add-only' ></textarea>
                </p>
                <table>
                    <tr>
                        <td className="signature w-600">&nbsp;
                        </td>
                        <td className="signature w-150">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-600'>&nbsp; </td>
                        <td className='small w-150'>Date  </td>
                    </tr>
                    <tr>
                        <td className="signature w-600">&nbsp; </td>
                        <td className="signature w-150">&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'>&nbsp;
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>





            </div>
        </form >

    )
}







